import { Offer } from '@funtech-int/yango-shared';

export const TARIFFICATOR_BILLING_PRODUCT_ID = 'tarifficator';

// OfferAnalytics перейдет в OfferPlacementAnalytics после задачи SAFTWEB-2505 Перевести методы аналитики на подход с отложенной установкой данных
export interface OfferAnalytics {
    showed(this: void, offer: Offer): void;
    navigated(this: void, offer: Offer): void;
    succeeded(this: void, offer: Offer): void;
}

export interface OfferPlacementAnalytics {
    showed(this: void): void;
    navigated(this: void): void;
    succeeded(this: void): void;
}
